import { useContext } from 'react';
import RecentSearches from '@/home/ReturnUser/RecentSearches';
import RecommendedCarousels from '@/home/ReturnUser/RecommendedCarousels';
import { useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/home/GlobalContext';
import HeroSection from './HeroSection';
import TopCarousels from './TopCarousels';
import BudgetFriendlyCarousel from '../common/BudgetFriendlyCarousel';
import MarketingCarousel from '../common/MarketingCarousel';
import PopularBodyStyles from '../common/PopularBodyStyles';
import PriceDropBanner from '../common/PriceDropBanner';
import ShopPopularModels from '../common/ShopPopularModels';

export default function ReturnUser() {
  const isNative = useIsNative();
  const { displayLowerFoldOnNative } = useContext(GlobalContext);
  const showRecommendedCarousels = isNative ? displayLowerFoldOnNative : true;

  return (
    <main data-testid="home-return-user">
      <HeroSection />
      <TopCarousels />
      <RecentSearches />
      <PriceDropBanner />
      <PopularBodyStyles />
      <BudgetFriendlyCarousel />
      {showRecommendedCarousels && <RecommendedCarousels />}
      <div className="bg-background-default">
        <MarketingCarousel />
      </div>
      <ShopPopularModels />
    </main>
  );
}
